(()=>{
"use strict";
  window.addEventListener('DOMContentLoaded',function(){

    document.querySelectorAll('.js-accordion').forEach((item)=>{

      const ac_panel = item.querySelector('.js-accordionPanel');
      const ac_panelH = ac_panel.clientHeight;
      const ac_title = item.querySelector('.js-accordionTitle');

      if(item.classList.contains('is-open') ){
        ac_panel.style.transition = 'none';
        ac_panel.style.height = `${ac_panel.scrollHeight}px`;
        this.setTimeout(function(){
          ac_panel.style.transition = null;
        })
      }

      ac_title.addEventListener("click",()=>{
        item.classList.toggle("is-open");
        if (ac_panel.style.height) {
          ac_panel.style.height = null;
        } else {
          ac_panel.style.height = ac_panel.scrollHeight + 'px';
        }
      });

    });

  });


})();
